import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPointerFlash = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 21,
	height: 25,
	fill: "none",
	viewBox: "0 0 21 25",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M10.23 5.3a1 1 0 0 1-1-1v-3a1 1 0 0 1 2 0v3a1 1 0 0 1-1 1Zm-5 5a1 1 0 0 0-1-1h-3a1 1 0 0 0 0 2h3a1 1 0 0 0 1-1Zm1.43-3.47a1 1 0 0 0 0-1.41L4.54 3.3A1 1 0 1 0 3.13 4.7l2.12 2.12a1 1 0 0 0 1.41 0Zm8.52-.07 2.12-2.12a1 1 0 1 0-1.41-1.42l-2.13 2.12a1 1 0 1 0 1.42 1.42Zm4.64 8.85-7.96-7.79c-1.43-1.2-3.63-.21-3.63 1.63v11.24c0 1.18 1.4 1.8 2.3 1.03l2.02-1.8 1.61 3.26a2.1 2.1 0 0 0 3.1.7c.82-.6 1.01-1.76.55-2.67l-1.42-2.9 2.64-.38a1.36 1.36 0 0 0 .79-2.32Z"
	})
});
export default SvgPointerFlash;
